import { render } from "./LoginView.vue?vue&type=template&id=af74129c&ts=true"
import script from "./LoginView.vue?vue&type=script&lang=ts"
export * from "./LoginView.vue?vue&type=script&lang=ts"

import "./LoginView.vue?vue&type=style&index=0&id=af74129c&lang=less"

import exportComponent from "/srv/stamincasa/stamincasa-matematica/frontend/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__